import moment from 'moment'
export default {
  getRichmenuTemplate: function (state) {
    return state.richmenuTemplate
  },
  getPresetmenu: function (state) {
    return state.presetMenu
  },
  getTemplateSelect: function (state) {
    if (typeof state.templateSelect.content_json === 'string') {
      state.templateSelect.content_json = JSON.parse(
        state.templateSelect.content_json
      )
    }
    return state.templateSelect
  },
  getLineRichMenu: function (state) {
    return state.lineRichMenu
  },
  getImageSelect: function (state) {
    return state.imageSelect
  },
  getUploadSelectType: function (state) {
    return state.uploadSelectType
  },
  getTypeEditNew: function (state) {
    return state.setTypeEditNew
  },
  getIdTemplate: function (state) {
    return state.idTemplate
  },
  getPackageRichmenu: function (state) {
    return state.packageRichmenu
  },
  getScale: function (state) {
    return state.scale
  },
  getGroupId: function (state) {
    if (state.groupId) {
      // console.log(state.groupId);
      let a = moment(state.groupId.expired_timestamp)
      let b = moment()

      return {
        ...state.groupId,
        expiredTime: a.diff(b),
        expiredDay: a.diff(b, 'days')
      }
    } else return null
  },
  getClickTrial: function (state) {
    // console.log(state.clickTrial);
    return state.clickTrial
  }
}
